import { Component, OnInit, Input, EventEmitter, Output, ViewChildren, QueryList, ViewChild, AfterViewInit } from '@angular/core';
import { ContactInfo } from 'src/app/models/waiver';
import { ControlContainer, NgForm, NgModel, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { CustomFields } from 'src/app/models/custom-fields';
import { CustomFieldComponent } from '../custom-field/custom-field.component';

@Component({
  selector: 'guest-contactinfo-edit',
  templateUrl: './guest-contactinfo-edit.component.html',
  styleUrls: ['./guest-contactinfo-edit.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class GuestContactinfoEditComponent implements OnInit, AfterViewInit {

  @Input() info: ContactInfo;
  @Input() formSubmitted: boolean;
  @Input() customIndex: number = 0;
  @Input() customFields: CustomFields[];
  @ViewChildren(CustomFieldComponent) customFieldControls: QueryList<CustomFieldComponent>;
  @ViewChild('phoneNo') phoneNoRef: NgModel;

  constructor() {
    !this.info && (this.info = new ContactInfo());
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.phoneNoRef && this.phoneNoRef.control) {
      const phoneValidator = (c: AbstractControl): ValidationErrors | null => {
        const val = c.value;
        if (!val || (typeof val === 'string' && val.trim() === '')) return null;
        return this.isValidPhoneNumber(String(val).trim()) ? null : { invalidPhone: true };
      };
      this.phoneNoRef.control.setValidators([Validators.required, phoneValidator]);
      this.phoneNoRef.control.updateValueAndValidity();
    }
  }

  isValidPhoneNumber(phoneNumber: string): boolean {
      var pattern = /^\(\d{3}\) \d{3}-\d{4}$/;
    if (!pattern.test(phoneNumber)) return false;
    const digits = (phoneNumber || '').replace(/\D/g, '');
    return digits.length === 10;
  }

  formatUSPhone(value: string): string {
    let digits = (value || '').replace(/\D/g, '');
    if (digits.startsWith('1') && digits.length > 10) {
      digits = digits.substring(1);
    }
    digits = digits.substring(0, 10);
    if (digits.length === 0) return '';
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  onPhoneFocus(): void {
    if (this.info && this.info.phone) {
      this.info.phone = this.info.phone.replace(/\D/g, '');
    }
  }

  onPhoneBlur(): void {
    if (this.info && this.info.phone !== '') {
      this.info.phone = this.formatUSPhone(this.info.phone);
      if (this.phoneNoRef && this.phoneNoRef.control) {
        this.phoneNoRef.control.updateValueAndValidity();
      }
    }
  }
}
